import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Ornament } from './Ornament';
const costs = ['Hours spent searching for exercises and class ideas.', 'Repeating the same thigh and glute sequences because there was no time to prepare something different.', 'Struggling to create enough variety without losing the Barre structure.', 'Beginners needing easier options while stronger students need more challenge.', 'Having good exercises but no clear progression connecting them.', 'Losing time deciding how long each block should last.', 'Wondering when to move from thighs to glutes, balance, mat work or a finisher.', 'Giving corrections on the spot instead of having clear coaching cues prepared.', 'Classes that feel disconnected from one week to the next.', 'More time planning and less time teaching.'];
export function PainPoints() {
  return <section className="bg-surface-subtle px-4 py-20 sm:py-28" data-id="element-224" data-mp="3ncxuu9sn0frb">
      <div className="mx-auto max-w-3xl" data-id="element-225" data-mp="1z0osmra3htga">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-226" data-mp="1yzn5vpjpviiq">
          <h2 className="text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-227" data-mp="23rdik264midb">
            Does This Sound <span className="italic text-primary" data-id="element-228" data-mp="23tresecjm0mg">Familiar?</span>
          </h2>
          <Ornament className="mt-5" data-id="element-229" data-mp="1g3x0dscks403" />
          <div className="mt-8 rounded-xl border border-primary/15 bg-surface p-6 text-left text-base leading-7 text-muted-foreground shadow-card sm:p-8" data-id="element-230" data-mp="1b39bbc7wpx8i">
            <p className="font-display text-xl font-semibold text-foreground" data-id="element-231" data-mp="1p3si6g0myx93">
              Another Barre class is coming.
            </p>
            <p className="mt-4" data-id="element-232" data-mp="30he7c16hwyum">
              And instead of already knowing exactly what you are going to
              teach, you are going through old notes, saved workouts,
              screenshots, videos and previous class plans trying to build
              something that feels fresh, balanced and professional.
            </p>
            <p className="mt-4" data-id="element-233" data-mp="1y2wzwuy3q5wz">
              <strong className="font-semibold text-foreground" data-id="element-234" data-mp="1y62qyfqajhvc">
                Not because you do not know Barre.
                <br data-id="element-235" data-mp="274o6e20gugrw" />
                Not because you do not know how to teach.
              </strong>
            </p>
            <p className="mt-4" data-id="element-236" data-mp="1af713o5eawqq">
              But because creating structured classes week after week takes
              time.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-237" data-mp="1jflrh1x7v213">
          <h3 className="text-center text-2xl font-semibold text-foreground" data-id="element-238" data-mp="1jeamiys1bo8e">
            And every time you start from zero, the same problems appear:
          </h3>
          <ul className="mt-7 space-y-3" data-id="element-239" data-mp="qqxzyolvjgf3">
            {costs.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04
          }} className="flex items-start gap-3 rounded-lg border border-primary/15 bg-surface px-5 py-4 text-sm leading-6 text-foreground" data-id="element-240" data-mp="vprfsnomvjif" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-primary" aria-hidden="true" data-id="element-241" data-mp="a70bryg5hdc3" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-accent/40 pt-8 text-center" data-id="element-242" data-mp="f31ctwyupef">
            <p className="font-display text-3xl font-semibold text-foreground" data-id="element-243" data-mp="3ro0biu4imdq3">
              Your experience is <span className="italic text-primary" data-id="element-244" data-mp="3mox5b6csu1gj">already there.</span>
            </p>
            <p className="mx-auto mt-3 max-w-xl text-lg font-medium text-muted-foreground" data-id="element-245" data-mp="3imk32rx9gloi">
              What you need is a system that helps you organize it, visualize
              it and teach it faster.
            </p>
          </div>
        </div>
      </div>
    </section>;
}